import React from "react";
import styles from "./TextArea.module.css";

export default function TextArea({
  value,
  onChange,
  placeholder = "",
  rows = 4,
  className = "",
  ...rest
}) {
  return (
    <textarea
      className={[styles.textarea, className].join(" ")}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
      {...rest}
    />
  );
}